
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: 'lista',
	filtro: {},
	lista: [],
	listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'CONTROLE_ROUTE_ID_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'CONTROLE_ROUTE_ID_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

		case 'CONTROLE_ROUTE_ID_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'CONTROLE_ROUTE_ID_LISTADO':
            return {
				...state,
				lista: action.payload.data,
				listaSelect: action.payload.data.map(item => ({
					id: item.id,
					valor: item.nome,
					id_setor: item.id_setor,
					obrigatoria: item.obrigatoria
				}))
			};

        default:
            return state;
    }
}
